import { useContext } from 'react';
import { StripeContext } from '../context/stripeContextDefinition';

export const useStripeContext = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error('useStripeContext must be used within StripeProvider');
  }
  return context;
};
